import styles from './AccountSummary.module.scss'

const AccountSummary = () => {
	return (
		<div className={styles.AccountSummaryContainer}>
			<div className={styles.AccountSummaryCredits}>
				<small className={styles.AccountSummaryTitile}>Total Credits</small>
				<p className={styles.credits}>
					NGN 3,287,902.<span className={styles.creditsSpan}>00</span>
				</p>
			</div>
			{window.innerWidth > 768 && (
				<div className={styles.AccountSummarySettlements}>
					<small className={styles.AccountSummaryTitile}>
						Total Transfer Settlements
					</small>
					<p className={styles.settlements}>81 Settlements</p>
				</div>
			)}

			<div className={styles.AccountSummaryGenerated}>
				<small className={styles.AccountSummaryTitile}>
					Generated Accounts
				</small>
				<p className={styles.genetated}>12 Accounts</p>
			</div>
		</div>
	)
}

export default AccountSummary
